<div class="page-container rep-management-container container">
  <app-utility-toolbar />
  <h1 class="header col-12">Rep Management</h1>
  <form [formGroup]="searchForm">
    <div class="row">
      <mat-form-field class="col-3">
        <input
          matInput
          [formControlName]="'repcode'"
          [placeholder]="'Rep Code'"
        />
      </mat-form-field>
      <mat-form-field class="col-3">
        <input matInput [formControlName]="'name'" [placeholder]="'Name'" />
      </mat-form-field>
      <mat-form-field class="col-3">
        <input
          matInput
          [formControlName]="'unitname'"
          [placeholder]="'Unit Name'"
        />
      </mat-form-field>
      <mat-form-field class="col-3">
        <input
          matInput
          [formControlName]="'unitid'"
          [placeholder]="'Unit ID'"
        />
      </mat-form-field>
    </div>
    <div class="col-12 buttons mt-2 mb-3">
      <button
        mat-raised-button
        color="accent"
        class="pull-right"
        type="submit"
        (click)="newSearch()"
        >Search</button
      >
      <button mat-raised-button class="pull-right me-2" (click)="clearSearch()"
        >Clear Search</button
      >
      <button mat-button color="primary" (click)="openCreateRepDialog()"
        ><mat-icon>add</mat-icon>Add Rep</button
      >
    </div>
  </form>
  <kendo-grid
    #grid
    [data]="gridView"
    [height]="700"
    [pageSize]="state.take"
    [pageable]="true"
    [skip]="state.skip"
    [filterable]="false"
    [filter]="state.filter"
    [sortable]="{
      mode: multiple ? 'multiple' : 'single',
    }"
    [sort]="sort"
    [isDetailExpanded]="expandSelected"
    [navigable]="true"
    (pageChange)="pageChange($event)"
    (dataStateChange)="dataStateChange($event)"
    (detailCollapse)="detailCollapse($event)"
    (detailExpand)="detailExpand($event)"
    (sortChange)="sortChange($event)"
  >
    <kendo-grid-column field="repCode" title="Rep Code" />
    <kendo-grid-column field="repName" title="Name" />
    <kendo-grid-column field="UnitName" title="Unit Name" />
    <kendo-grid-column field="UnitId" title="Unit ID" />
    <kendo-grid-column field="Active" title="Active" />
    <ng-template let-dataItem let-rowIndex kendoGridDetailTemplate>
      <section>
        <form [formGroup]="gridForm" (save)="saveUser($event)">
          <input type="hidden" [formControlName]="'repCode'" />
          <mat-form-field class="col-3">
            <mat-label>Name</mat-label>
            <input
              matInput
              [formControlName]="'repName'"
              [placeholder]="'Name'"
            />
            <mat-error>This field is required</mat-error>
          </mat-form-field>
          <mat-form-field class="col-3">
            <mat-label>Unit</mat-label>
            <mat-select required [formControlName]="'UnitId'">
              @for (unit of unitData; track unit) {
                <mat-option value="{{ unit.id }}">{{ unit.name }}</mat-option>
              }
            </mat-select>
            <mat-error>This field is required</mat-error>
          </mat-form-field>
          <mat-form-field class="col-3">
            <mat-label>Active</mat-label>
            <mat-select [formControlName]="'Active'" [placeholder]="'Active'">
              <mat-option value="1">Yes</mat-option>
              <mat-option value="0">No</mat-option>
            </mat-select>
            <mat-error>This field is required</mat-error>
          </mat-form-field>
          <div class="col-12">
            <button
              mat-raised-button
              class="pull-right"
              color="accent"
              (click)="saveRep(dataItem)"
              >Save</button
            >
            <button
              mat-raised-button
              class="pull-right me-2"
              (click)="detailCollapse()"
              >Cancel</button
            >
            <!-- <button mat-button (click)="deleteRep(dataItem)">Delete</button>           -->
          </div>
        </form>
      </section>
    </ng-template>
  </kendo-grid>
</div>
